class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (cartLink) {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    // console.log($(".you_may_also_like").length);
    if ($(".you_may_also_like").length == 0) {
      var custom_item_id = $(".cart-item__name").attr("item-id");
      $.ajax({
        url: window.Shopify.routes.root + "recommendations/products.json",
        method: "GET",
        data: {
          product_id: custom_item_id,
          limit: 4,
          intent: "related",
        },
      }).done(function (response) {
        var html =
          '<div class="you_may_also_like prevnext right_nav_top"><div class="heading_wrap"><h2>You May Also Like</h2></div><div class="slider_wrap">';
        $.each(response.products, function (index, product) {
          // console.log(product.variants[0].id);
          html +=
            '<div class="grid__item"><div class="product-card-wrapper"><div class="product-img-div"><a href="' +
            product.url +
            '"><img src="' +
            product.images +
            '" alt="" class="cart-recomendation-product"></a></div><div class="product-text-div"><div class="title_wrap"><a href="' +
            product.url +
            '">' +
            product.title +
            '</a></div><form class="form_ctc_drawer"><input type="hidden" name="pid" value="' +
            product.id +
            '" /><input type="hidden" name="id" value="' +
            product.variants[0].id +
            '" /><input min="1" type="hidden" id="quantity" name="quantity" value="1"/><input type="button" value="Add to cart | $' +
            product.variants[0].price / 100 +
            ".00" +
            '" class="atc_cart_drawer button" /></form></div></div></div>';
        });

        html += "</div></div>";

        document.body.classList.add("overflow-hidden");
        $(".drawer__cart-items-wrapper").append(html);
        $(".slider_wrap").slick({
          slidesToScroll: 1,
          slidesToShow: 2,
          infinite: true,
          arrows: true,
          dots: true,
        });
      });
    }
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    $(".you_may_also_like").remove();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

var type = getUrlParameter("type");
var pid = getUrlParameter("pid");
if (type == "cart_update") {
  $("cart-drawer").addClass("active");
  $("body").addClass("overflow-hidden");

  if ($(".you_may_also_like").length == 0) {
    var custom_item_id = pid;
    $.ajax({
      url: window.Shopify.routes.root + "recommendations/products.json",
      method: "GET",
      data: {
        product_id: custom_item_id,
        limit: 4,
        intent: "related",
      },
    }).done(function (response) {
      var html =
        '<div class="you_may_also_like prevnext right_nav_top"><div class="heading_wrap"><h2>You May Also Like</h2></div><div class="grid slider_wrap">';
      $.each(response.products, function (index, product) {
        //console.log(product.variants[0].id);
        html +=
          '<div class="grid__item"><div class="product-card-wrapper"><div class="product-img-div"><a href="' +
          product.url +
          '"><img src="' +
          product.images +
          '" alt="" class="cart-recomendation-product"></a></div><div class="product-text-div"><div class="title_wrap"><a href="' +
          product.url +
          '">' +
          product.title +
          '</a></div><form class="form_ctc_drawer"><input type="hidden" name="id" value="' +
          product.variants[0].id +
          '" /><input min="1" type="hidden" id="quantity" name="quantity" value="1"/><input type="button" value="Add to cart | $' +
          product.variants[0].price / 100 +
          ".00" +
          '" class="atc_cart_drawer button" /></form></div></div></div>';
      });

      html += "</div></div>";
      $(".drawer__cart-items-wrapper").append(html);
    });
  }
}

// $(document).on("click", ".atc_cart_drawer", function () {
//   var form_ctc_drawer_id = $(this).parent().find('input[name="id"]').val();
//   var pid = $(this).parent().find('input[name="pid"]').val();
//   let formData = {
//     items: [
//       {
//         id: form_ctc_drawer_id,
//         quantity: 1,
//       },
//     ],
//   };
//   fetch(window.Shopify.routes.root + "cart/add.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(formData),
//   })
//     .then((response) => {
//       //console.log(response);
//       //console.log(response.status);
//       window.location.reload();
//       return response.json();
//     })
//     .catch((error) => {
//       console.error("Error:", error);
//     });
// });


// without load in add to cart product add in cart drawer

// $(document).on("click", ".atc_cart_drawer", function () {
//   const $form = $(this).closest("form");
//   const variantId = $form.find('input[name="id"]').val();

//   let formData = {
//     items: [
//       {
//         id: variantId,
//         quantity: 1,
//       },
//     ],
//   };

//   fetch(window.Shopify.routes.root + "cart/add.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(formData),
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       // ✅ After product is added, refresh cart drawer
//       fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`)
//         .then((res) => res.json())
//         .then((sections) => {
//           const drawer = document.querySelector("cart-drawer");
//           drawer.renderContents({
//             id: data.id,
//             sections: {
//               "cart-drawer": sections["cart-drawer"],
//               "cart-icon-bubble": sections["cart-icon-bubble"],
//             },
//           });
//         });
//     })
//     .catch((error) => {
//       console.error("Add to cart failed:", error);
//     });
// });





$(document).on("click", ".atc_cart_drawer", function () {
  const $form = $(this).closest("form");
  const variantId = $form.find('input[name="id"]').val();

  let formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      // 🛒 Reload cart drawer + you-may-like section + cart icon
      fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble,you-may-like`)
        .then((res) => res.json())
        .then((sections) => {
          const drawer = document.querySelector("cart-drawer");
          if (drawer && drawer.renderContents) {
            drawer.renderContents({
              id: data.id,
              sections: {
                "cart-drawer": sections["cart-drawer"],
                "cart-icon-bubble": sections["cart-icon-bubble"],
                "you-may-like": sections["you-may-like"],
              },
            });
          }

          // 👇 Optional: manually replace "You may like" section if needed
          const youMayLike = document.querySelector(".you_may_also_like"); // adjust selector as needed
          if (youMayLike && sections["you-may-like"]) {
            youMayLike.innerHTML = new DOMParser()
              .parseFromString(sections["you-may-like"], "text/html")
              .body.innerHTML;
          }
        });
    })
    .catch((error) => {
      console.error("Add to cart failed:", error);
    });
});
